import React from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'

interface IconButtonProps {
  color?: string
  path?: string
  margin?: string
  active?: boolean
  classNameB?: string
  onClick?: () => void
}

const IconButton = ({onClick, color, path='/media/icons/duotune/arrows/arr015.svg',margin='me-5',classNameB='svg-icon-2x',active=true}: IconButtonProps) => {
  let activeCSS = active? ' point':' auto'
  return (
    <div className={'d-flex justify-content-end '+margin}>
      <a href={'#'} className={'ms-auto'+ activeCSS} onClick={onClick}>
        <KTSVG
          path={path}
          className={'svg-icon ' + classNameB}
          color={color}
        />
      </a>
    </div>
  )
}

export default IconButton
